import script from "./MessageFeedbackSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageFeedbackSummary.vue?vue&type=script&setup=true&lang=js"

import "./MessageFeedbackSummary.vue?vue&type=style&index=0&id=0dbb0f7a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindBack\\VindBackVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dbb0f7a"]])

export default __exports__